import { render, staticRenderFns } from "./InformationsComplementaires.vue?vue&type=template&id=0d123d84&scoped=true"
import script from "./InformationsComplementaires.vue?vue&type=script&lang=js"
export * from "./InformationsComplementaires.vue?vue&type=script&lang=js"
import style0 from "./InformationsComplementaires.vue?vue&type=style&index=0&id=0d123d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d123d84",
  null
  
)

export default component.exports